var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RestClient } from '@pegasus/rest-client';
import camelcaseKeys from 'camelcase-keys-all-env';
import { convertFiltersForClient, convertFiltersForServer } from './helpers';
var crossCampaignCategoryFilterAbortController;
export var fetchFilterForCrossCampaignCategory = function () {
    if (crossCampaignCategoryFilterAbortController) {
        crossCampaignCategoryFilterAbortController.abort();
    }
    crossCampaignCategoryFilterAbortController = new AbortController();
    return RestClient.get('/api/phoenix/catalog/filter-counts')
        .withClientType('web')
        .acceptStatusCodes([200])
        .withQueryParameters({
        fields: 'category_filter',
        no_soldout: 1,
    })
        .withAbortController(crossCampaignCategoryFilterAbortController)
        .send()
        .then(function (res) { return res.json(); })
        .then(function (data) { return camelcaseKeys(data, { deep: true }); })
        .finally(function () {
        crossCampaignCategoryFilterAbortController = null;
    });
};
var allCrossCampaignFiltersAbortController;
export var fetchFiltersForAllCrossCampaign = function (activeFilter, shouldExposeFilters) {
    if (allCrossCampaignFiltersAbortController) {
        allCrossCampaignFiltersAbortController.abort();
    }
    allCrossCampaignFiltersAbortController = new AbortController();
    var filterCountsRestClient = RestClient.get('/api/phoenix/catalog/filter-counts');
    if (shouldExposeFilters) {
        filterCountsRestClient.withHeaders({
            'X-Exposed-Filters': 'true',
        });
    }
    return filterCountsRestClient
        .withClientType('web')
        .acceptStatusCodes([200])
        .withQueryParameters(__assign(__assign({}, convertFiltersForServer(activeFilter)), { fields: 'category_filter,color_filter,gender_filter,price_filter,size_filter,brand_filter,material_filter,length_filter', no_soldout: 1, use_score_size_filter_sort: true }))
        .withAbortController(allCrossCampaignFiltersAbortController)
        .send()
        .then(function (res) { return res.json(); })
        .then(function (json) { return convertFiltersForClient(json); })
        .finally(function () {
        allCrossCampaignFiltersAbortController = null;
    });
};
var campaignFiltersAbortController;
export var fetchFiltersForCampaign = function (campaignIdentifier, activeFilter, shouldRemoveSoldOut) {
    if (campaignFiltersAbortController) {
        campaignFiltersAbortController.abort();
    }
    campaignFiltersAbortController = new AbortController();
    return RestClient.get("/api/phoenix/catalog/events/".concat(campaignIdentifier, "/filter-counts"))
        .withSpanName('GET - /api/phoenix/catalog/events/{campaignIdentifier}/filter-counts')
        .withSpanAttributes([{ name: 'campaignIdentifier', value: campaignIdentifier }])
        .withClientType('web')
        .acceptStatusCodes([200])
        .withQueryParameters(__assign(__assign({}, convertFiltersForServer(activeFilter)), { fields: 'category_filter,color_filter,gender_filter,price_filter,size_filter,brand_filter,material_filter,length_filter', no_soldout: shouldRemoveSoldOut, use_score_size_filter_sort: true }))
        .withAbortController(campaignFiltersAbortController)
        .send()
        .then(function (res) { return res.json(); })
        .then(function (json) { return convertFiltersForClient(json); })
        .finally(function () {
        campaignFiltersAbortController = null;
    });
};
